// Lightweight per-page SEO helpers for the SPA.
// Sets the document title and the meta description so each primary page is unique.
// Optional: canonical URL and Open Graph tags (used by Journal articles).
function upsertMeta(selector, create, content) {
  let m = document.querySelector(selector);
  if (!m) { m = create(); document.head.appendChild(m); }
  m.setAttribute("content", content);
}

export function setSeo({ title, description, canonical, og }) {
  if (title) document.title = title;
  if (description) {
    upsertMeta('meta[name="description"]', () => { const m = document.createElement("meta"); m.name = "description"; return m; }, description);
  }
  if (canonical) {
    let l = document.querySelector('link[rel="canonical"]');
    if (!l) { l = document.createElement("link"); l.rel = "canonical"; document.head.appendChild(l); }
    l.href = canonical;
  }
  if (og) {
    Object.entries(og).forEach(([prop, val]) => {
      if (!val) return;
      upsertMeta(`meta[property="og:${prop}"]`, () => { const m = document.createElement("meta"); m.setAttribute("property", `og:${prop}`); return m; }, val);
    });
  }
}
